import { biliBridge, inBiliApp } from "@bilibili/js-bridge";

export function getScheme(type, extra) {
  switch (type) {
    case "video": {
      return `bilibili://video/${extra}`;
    }
    case "browser": {
      return `bilibili://browser?url=${encodeURIComponent(extra)}`;
    }
    default: {
      return `bilibili://browser?url=${encodeURIComponent(extra)}`;
    }
  }
}

export function openScheme(scheme: string) {
  if (inBiliApp) {
    biliBridge.callNative({
      method: "ability.openScheme",
      data: {
        url: scheme
      }
    });
  }
}

export default function openUrl(url: string) {
  if (inBiliApp) {
    biliBridge.callNative({
      method: "ability.openScheme",
      data: {
        url: `bilibili://browser/?url=${encodeURIComponent(url)}`
      }
    });
  } else {
    window.open(url, "_blank");
  }
}
